export default __webpack_public_path__ + "d5f85a925dcea37f20727a33bb29e96a.ogg";